import { render, staticRenderFns } from "./RestorationApplications.vue?vue&type=template&id=52ac989c&scoped=true&"
import script from "./RestorationApplications.vue?vue&type=script&lang=js&"
export * from "./RestorationApplications.vue?vue&type=script&lang=js&"
import style0 from "./RestorationApplications.vue?vue&type=style&index=0&id=52ac989c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac989c",
  null
  
)

export default component.exports